import { render } from "./App.vue?vue&type=template&id=2798714a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2798714a&lang=css"
script.render = render

export default script